<template>
  <div style="position: relative;" class="bg-white pl-4 pt-4 rounded">
    <div>
      <div class="d-flex justify-content-between" style="margin-bottom: 1.70rem;">
        <div class="d-flex align-items-center" style="gap: 2.34rem;">
          <div>
            <h1 class="title">{{ $t("risk.organization") }}</h1>
          </div>
          <div class="search2">
            <div class="search2--icon"><i class="iconoir-search"></i></div>
            <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
          </div>
        </div>

        <b-dropdown v-if="this.currentProduct" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="m-2">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
        </b-dropdown>

        <right-panel class="float-right" id="sidebar-add-new-risk" width="1300px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <organizationRiskForm :product="currentProduct || 'RISK'" />
          </div>
        </right-panel>

        <a v-if="(hasRiskAdminPermission && this.currentProduct) || hasDepartmentAndProcessAdminPermission" @click="$root.$emit('bv::toggle::collapse', 'sidebar-add-new-risk')">
          <div class="d-flex align-items-center">
            <div class="new-task-text">{{ $t("risk.new") }}</div>
            <div class="plus-button" style="margin-right: 1.56rem;"></div>
          </div>
        </a>
      </div>
      <nav class="tab-menu">
        <div
          :class="{ active: activeTab === 'ORGANIZATION_RISKS' }"
          @click="
            activeTab = 'ORGANIZATION_RISKS';
            activeSubTab = 'ACTIVE';
          "
        >
          {{ $t("risk.organization") }}
        </div>

        <div :class="{ active: activeTab === 'MY_APPROVALS' }" @click="activeTab = 'MY_APPROVALS'">{{ $t("risk.approval.my") }}</div>
        <!-- <div v-if="hasViewUnworkedRiskPermission" :class="{ active: activeTab === 'unworked' }" @click="activeTab = 'unworked'">{{ $t("risk.unworked") }}</div> -->
      </nav>
      <div class="mt-4">
        <content-loading v-if="isLoading" />
        <div class="mb-4" v-if="activeTab === 'ORGANIZATION_RISKS'">
          <nav class="tab-menu">
            <!-- <div :class="{ active: activeSubTab === 'EVALUATION_PENDING' }" @click="activeSubTab = 'EVALUATION_PENDING'">
              {{ $t("risk.tab.evaluation-pending") }}
            </div> -->
            <div :class="{ active: activeSubTab === 'ACTIVE' }" @click="activeSubTab = 'ACTIVE'">
              {{ $t("risk.tab.active") }}
            </div>
            <div :class="{ active: activeSubTab === 'COMPLETED' }" @click="activeSubTab = 'COMPLETED'">
              {{ $t("risk.tab.completed") }}
            </div>
            <div :class="{ active: activeSubTab === 'CLOSED' }" @click="activeSubTab = 'CLOSED'">
              {{ $t("risk.tab.closed") }}
            </div>

            <div :class="{ active: activeSubTab === 'ALL' }" @click="activeSubTab = 'ALL'">
              {{ $t("risk.tab.all") }}
            </div>
          </nav>
        </div>
        <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)" width="200px">
          <h5 class="text-center">
            {{ $t("common.no-data") }}
          </h5>
        </empty>
        <div v-if="!isLoading && pagination && pagination.docs.length > 0" class="rcontainer">
          <!---->
          <div class="rcard" v-for="risk in pagination.docs" :key="risk._id">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="rtitle hand" @click="edit(risk._id)">{{ risk.name | translate }}</div>
              <div class="pcard--actions">
                <!-- <i class="iconoir-page hand" @click="redirectToRelatedFiles(risk)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')"></i> -->
                <i class="iconoir-edit" @click="edit(risk._id)"></i>
                <i
                  class="bx bx-x-circle"
                  v-if="risk.status != 'CANCELED' && risk.status != 'CLOSED'"
                  @click="openCloseRiskModal(risk._id)"
                  v-b-tooltip.hover
                  :title="$t('risk.close')"
                ></i>
                <i
                  class="bx bx-minus-circle text-danger"
                  v-if="risk.status != 'CANCELED' && risk.status != 'CLOSED'"
                  @click="openCancelRiskModal(risk._id)"
                  v-b-tooltip.hover
                  :title="$t('risk.cancel')"
                ></i>
              </div>
            </div>

            <div class="rdefinition">{{ $t("risk.threat-definition.text") }}</div>
            <div class="rdescription">{{ stringify(risk.threats) }}</div>
            <div class="rdefinition">{{ $t("risk.weakness-definition.text") }}</div>
            <div class="rdescription">{{ stringify(risk.weaknesses) }}</div>

            <div class="rdefinition">{{ $t("risk.category.text") }}</div>
            <div class="rdescription">
              <span v-if="risk && risk.category">{{ risk.category.name | translate }}</span>
            </div>

            <div class="rflex-row">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.possibility") }}
              </div>
              <div>{{ risk.possibility }}</div>
            </div>
            <hr />
            <div class="rflex-row">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.effect") }}
              </div>
              <div>{{ risk.effectValue }}</div>
            </div>
            <hr />
            <div class="rflex-row text-white">
              <div>
                <div class="icon text-white"><i class="iconoir-shield-alert"></i></div>
                {{ $t("risk.risk-point") }}
              </div>
              <div>{{ risk.riskPoint }}</div>
            </div>

            <applied-risk-value-badge v-if="risk.appliedRiskValue" :risk="risk" />
          </div>
          <!---->
        </div>

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <b-modal id="close-risk-modal" :title="$t('risk.close')" @ok="handleCloseRiskOk">
        <b-form-group :label="$t('common.description')">
          <b-form-textarea v-model="closeNote" :placeholder="$t('common.description')" rows="3"></b-form-textarea>
        </b-form-group>
      </b-modal>
      <b-modal id="cancel-risk-modal" :title="$t('risk.cancel')" @ok="handleCancelRiskOk">
        <b-form-group :label="$t('common.description')">
          <b-form-textarea v-model="cancelNote" :placeholder="$t('common.description')" rows="3"></b-form-textarea>
        </b-form-group>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AppliedRiskValueBadge from "./component/applied-risk-value-badge";
import RiskCategoryBadge from "./component/risk-category-badge";
import organizationRiskForm from "./organization-risk-form.vue";

export default {
  components: { AppliedRiskValueBadge, RiskCategoryBadge, organizationRiskForm },
  data() {
    return {
      request: {
        options: { page: 1, limit: 9, sort: { name: "asc" } },
        query: {},
      },
      activeTab: "ORGANIZATION_RISKS",
      activeSubTab: "ACTIVE",
      nameFilter: undefined,
      closeNote: undefined,
      cancelNote: undefined,
      riskIdToCancel: undefined,
      riskIdToClose: undefined,
    };
  },

  computed: {
    activeStatus() {
      if (this.activeTab === "MY_APPROVALS") {
        return "MY_APPROVALS";
      }
      return this.activeSubTab;
    },
    pagination() {
      return this.$store.getters["organizationRisk/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationRisk/isLoading"];
    },
    hasRiskAdminPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
      ]);
    },
    hasDepartmentAndProcessAdminPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_GDPR_ACCESS",
        "ORGANIZATION_KVKK_ACCESS",
        "ORGANIZATION_BGYS_ACCESS",
        "ORGANIZATION_DDO_ACCESS",
        "ORGANIZATION_RISK_ACCESS",
      ]);
    },
    hasViewUnworkedRiskPermission() {
      return this.currentAccountHasPermissions(["ORGANIZATION_RISK_ADMIN"]);
    },
    hasApprovalPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
      ]);
    },
  },

  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },

    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },

    activeTab(n, o) {
      this.updateQuery();
    },
    activeSubTab(n, o) {
      this.updateQuery();
    },
  },
  mounted() {
    this.updateQuery();
  },
  methods: {
    stringify(arr) {
      return arr?.map((a) => a.name[this.currentLanguage]).join(", ") || "";
    },
    rightPanelClosed() {
      this.$store.commit("organizationRisk/reset");
      this.$store.commit("organizationRisk/copingEntity", undefined);
      this.$store.commit("organizationRisk/editedEntity", undefined);
      this.$store.commit("organizationRisk/risk", undefined);
      this.paginate();
    },
    // redirectToRelatedFiles(item) {
    //   const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
    //   this.$router.push({
    //     path: url,
    //     query: { risk: item._id, riskName: item.name?.[this.currentLanguage] },
    //   });
    // },
    updateQuery() {
      const newQuery = { ...this.request.query };

      // Clean up previous status/approval filters
      delete newQuery.status;
      delete newQuery["approvals.0.assignee._id"];
      delete newQuery["approvals.0.status"];

      delete newQuery["acceptanceApprovals.0.assignee._id"];
      delete newQuery["acceptanceApprovals.0.status"];
      delete newQuery.$or;

      if (this.activeTab === "MY_APPROVALS") {
        if (this.currentAccount) {
          newQuery.$or = [
            {
              "approvals.0.assignee._id": this.currentAccount._id,
              "approvals.0.status": "PENDING",
            },
            {
              "acceptanceApprovals.0.assignee._id": this.currentAccount._id,
              "acceptanceApprovals.0.status": "PENDING",
            },
          ];
        }
      } else {
        // Organization Controls Tab (using sub-tabs)
        switch (this.activeSubTab) {
          case "EVALUATION_PENDING":
            newQuery.status = {
              value: { $in: ["AWAITING_APPROVAL", "AWAITING_ACCEPTANCE_APPROVAL"] },
              isObject: true,
            };
            break;
          case "ACTIVE":
            newQuery.status = {
              value: { $in: ["EDIT_REQUESTED_EVALUATING", "REJECTED_EVALUATING", "ACTIVE"] },
              isObject: true,
            };
            break;
          case "COMPLETED":
            newQuery.status = { value: "COMPLETED", isObject: true };
            break;
          case "CLOSED":
            newQuery.status = { value: "CLOSED", isObject: true };
            break;
          case "ALL":
            break;
        }
      }

      this.request.query = newQuery;
      this.request.options.page = 1;
    },
    async paginate() {
      await this.$store.dispatch("organizationRisk/paginate", this.request);
    },

    edit(id) {
      this.$store.commit("organizationRisk/isEditing", true);
      this.$store.commit("organizationRisk/riskId", id);

      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/detail/${id}`);
    },
    handleQueryParams() {
      const queryParams = this.$route.query;

      const safeActiveTabs = ["approval"];

      if (!queryParams) {
        return;
      }

      if (queryParams.activeTab && safeActiveTabs.includes(queryParams.activeTab)) {
        this.activeTab = queryParams.activeTab;
      }
    },

    openCloseRiskModal(id) {
      this.riskIdToClose = id;
      this.closeNote = null;
      this.$bvModal.show("close-risk-modal");
    },
    async handleCloseRiskOk(e) {
      if (!this.closeNote) {
        e.preventDefault();
        this.$toast.error(this.$t("common.required"));
        return;
      }
      try {
        const descriptionObj = {};
        descriptionObj[this.$i18n.locale || "tr"] = this.closeNote;

        await this.$store.dispatch("organizationRisk/close", { id: this.riskIdToClose, description: descriptionObj });
        this.paginate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    openCancelRiskModal(id) {
      this.riskIdToCancel = id;
      this.cancelNote = null;
      this.$bvModal.show("cancel-risk-modal");
    },
    async handleCancelRiskOk(e) {
      if (!this.cancelNote) {
        e.preventDefault();
        this.$toast.error(this.$t("common.required"));
        return;
      }
      try {
        const descriptionObj = {};
        descriptionObj[this.$i18n.locale || "tr"] = this.cancelNote;

        await this.$store.dispatch("organizationRisk/cancel", { id: this.riskIdToCancel, description: descriptionObj });
        this.paginate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    }, //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.activeTab == "approval") {
          payload.downloadScope = "ACCOUNT_IN_ORGANIZATION";
        } else if (this.activeTab == "unworked") {
          payload.downloadScope = "UNWORKED_IN_ORGANIZATION";
        }
        payload.product = this.currentProduct;

        const { data: file } = await this.$store.dispatch(`organizationRisk/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { timeout: 5000 });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-view.scss";
</style>
